var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 53,
    viewBox: "0 0 62 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 31.7386C8 30.1101 6.20914 28.79 4 28.79C1.79086 28.79 0 30.1101 0 31.7386V50.0514C0 51.6798 1.79086 52.9999 4 52.9999C6.20914 52.9999 8 51.6798 8 50.0514V31.7386Z",
    fill: "#4D44B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 21.2319C26 19.6243 24.2091 18.321 22 18.321C19.7909 18.321 18 19.6243 18 21.2319V50.0892C18 51.6968 19.7909 53.0001 22 53.0001C24.2091 53.0001 26 51.6968 26 50.0892V21.2319Z",
    fill: "#4D44B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 2.96576C44 1.32781 42.2091 0 40 0C37.7909 0 36 1.32782 36 2.96576V50.0342C36 51.6722 37.7909 53 40 53C42.2091 53 44 51.6722 44 50.0342V2.96576Z",
    fill: "#4D44B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62 26.5055C62 24.8763 60.2091 23.5557 58 23.5557C55.7909 23.5557 54 24.8763 54 26.5055V50.0503C54 51.6794 55.7909 53.0001 58 53.0001C60.2091 53.0001 62 51.6794 62 50.0503V26.5055Z",
    fill: "#4D44B5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewsIcon);
export default __webpack_public_path__ + "static/media/Views-icon.9c2a98f3ac8baaf9489d56da10b43bf4.svg";
export { ForwardRef as ReactComponent };